export default "__VITE_ASSET__DjWCEaKP__"